// src/components/Navbar.js
import React from 'react';

const Navbar = () => (
  <div style={{ backgroundColor: '#333', color: 'white', padding: '15px' }}>
    <ul style={{ listStyleType: 'none' }}>
    </ul>
  </div>
);

export default Navbar;
